import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

function SecureImage({ id, alt, className, onClick }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let url;
    api.get(`/files/${id}`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); })
      .catch(() => setFailed(true));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [id]);
  if (failed) return <div className={`flex items-center justify-center bg-muted text-muted-foreground ${className}`}><ImageOff className="h-5 w-5" /></div>;
  if (!src) return <div className={`animate-pulse bg-muted ${className}`} />;
  return <img src={src} alt={alt} className={`object-cover ${className}`} onClick={onClick} />;
}

export function PhotoGrid({ photos = [] }) {
  const [open, setOpen] = useState(null);
  if (!photos.length) return <p className="text-sm text-muted-foreground" data-testid="no-photos">No photographs uploaded.</p>;
  return (
    <>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4" data-testid="photo-grid">
        {photos.map((p, i) => (
          <button key={p.id} type="button" onClick={() => setOpen(p)} data-testid={`photo-thumb-${i}`}
            className="overflow-hidden rounded-md border border-border focus-visible:ring-2 focus-visible:ring-ring">
            <SecureImage id={p.id} alt={p.original_filename || `Photograph ${i + 1}`} className="aspect-square w-full" />
          </button>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={() => setOpen(null)}>
        <DialogContent className="max-w-3xl bg-card">
          <DialogTitle className="text-sm">{open?.original_filename}</DialogTitle>
          {open && <SecureImage id={open.id} alt={open.original_filename} className="max-h-[75vh] w-full object-contain" />}
        </DialogContent>
      </Dialog>
    </>
  );
}

export { SecureImage };
